export default class Theme {
    constructor(data = {}) {
        this.id = data.id;
        this.libelle = data.libelle;
        this.colorPrimary = data.colorPrimary;
        this.colorPrimary = data.colorAccent;
    }
}
